import React from 'react'

export const NearAds = () =>
  <div className='sidebar-user-ostalo-item'>
    <a href='javascript:void (0)'>
      <i className='ico-user-oglasi-u-tvojoj-blizini ico' />
      <p>Pogledaj oglase iz tvoje okoline</p>
    </a>
  </div>
